import { render, staticRenderFns } from "./ModalConfirmarJuntarDocumento.vue?vue&type=template&id=59c72493&scoped=true"
import script from "./ModalConfirmarJuntarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarJuntarDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarJuntarDocumento.vue?vue&type=style&index=0&id=59c72493&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c72493",
  null
  
)

export default component.exports